module.exports = __webpack_public_path__ + "img/MB_lobby.5ce125a9.jpg";